import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A set of three surge (lightning) arresters on a steel base frame: tall ribbed
// porcelain stacks that bleed surges to earth, protecting substation gear. The
// grading ring and line terminal sit on top of each.
const PORC = "#c8cbcd";
const SHED = "#b3b7ba";
const STEEL = "#6c727a";
const TERM = "#b87333";

function arrester(x: number): Part[] {
  const out: Part[] = [
    { geometry: new THREE.BoxGeometry(0.16, 0.06, 0.16), color: STEEL, position: [x, 0.2, 0] },
    { geometry: new THREE.CylinderGeometry(0.045, 0.05, 0.62, 12), color: PORC, position: [x, 0.54, 0] },
  ];
  for (let i = 0; i < 6; i++) {
    out.push({ geometry: new THREE.CylinderGeometry(0.07, 0.07, 0.02, 12), color: SHED, position: [x, 0.3 + i * 0.1, 0] });
  }
  // Grading ring and terminal.
  out.push({ geometry: new THREE.TorusGeometry(0.07, 0.012, 4, 10), color: STEEL, position: [x, 0.84, 0], rotation: [Math.PI / 2, 0, 0] });
  out.push({ geometry: new THREE.SphereGeometry(0.03, 6, 5), color: TERM, position: [x, 0.9, 0] });
  return out;
}

export const surgeArrester = defineModel({
  id: "surge-arrester",
  batchId: "electric",
  name: "Surge arrester",
  tags: ["prop", "electric", "power", "grid", "substation", "lightning", "high-voltage"],
  summary: "Three porcelain surge arresters on a steel base frame.",
  footprint: 0.35,
  parts(): Part[] {
    return [
      { geometry: new THREE.BoxGeometry(0.7, 0.16, 0.22), color: STEEL, position: [0, 0.08, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.14, 0.05), color: "#5a6066", position: [-0.3, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.14, 0.05), color: "#5a6066", position: [0.3, 0.07, 0] },
      ...arrester(-0.22),
      ...arrester(0.0),
      ...arrester(0.22),
    ];
  },
  animations: [],
});
